export enum PhotographerQueries {
	GET_PHOTOGRAPHERS = `
    query Photographers(
        $where: PhotographerDtoFilterInput,
        $first: Int,
        $after: String ) {
            photographers(
                where: $where,
                first: $first,
                after: $after
            ) {
                nodes {
                    active
                    statusId
                    statusName
                    statusColor
                    companyId
                    companyName
                    shotCost
                    totalPaid
                    monthlyPaid
                    maxItems
                    discountThreshold
                    discountPercentage
                    hiredFrom
                    hiredUntil
                    automaticRenewal
                    personId
                    firstName
                    lastName
                    fullName
                    brands{
                        brandId
                        brandName
                    }
                }

                totalCount
            }
        }
    `,
	GET_PHOTOGRAPHER_STATUSES = `
    query PhotographerStatus {
        photographerStatus {
            totalCount
            nodes {
                id
                tag
            }
        }
    }

     `
}
